import {
  OnChangeFn,
  RowData,
  Table,
  TableFeature,
  Updater,
  functionalUpdate,
  makeStateUpdater,
} from '@tanstack/react-table'

export const IsMultiSortFeature: TableFeature<any> = {
  getInitialState: (state): IsMultiSortTableState => {
    return {
      isMultiSort: false,
      ...state,
    }
  },
  getDefaultOptions: <TData extends RowData>(table: Table<TData>): IsMultiSortOptions => {
    return {
      onIsMultiSortChange: makeStateUpdater('isMultiSort', table),
    } as IsMultiSortOptions
  },
  createTable: <TData extends RowData>(table: Table<TData>): void => {
    table.setIsMultiSort = (updater) => {
      const safeUpdater: Updater<IsMultiSort> = (old) => {
        const newState = functionalUpdate(updater, old)
        return newState
      }
      return table.options.onIsMultiSortChange?.(safeUpdater)
    }
  },
}

// define types for our new feature's custom state
export type IsMultiSort = boolean

export interface IsMultiSortTableState {
  isMultiSort: any
}

// define types for our new feature's table options
export interface IsMultiSortOptions {
  onIsMultiSortChange?: OnChangeFn<IsMultiSort>
}

// Define types for our new feature's table APIs
export interface IsMultiSortInstance {
  setIsMultiSort: (updater: Updater<IsMultiSort>) => void
}
